import Card from "components/card";
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import {MdArrowDropDown, MdArrowDropUp} from "react-icons/md";
import React from "react";

const Widget2 = ({icon, title, subtitle, percentage}) => {
    if(percentage === undefined){
        percentage = "-"
    }
    return (
        <Card extra="!flex-row flex-grow items-center rounded-[20px]">
            <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
                <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
                    <span className="flex items-center text-brand-500 dark:text-white">
                        {icon}
                    </span>
                </div>
            </div>

            <div className="h-50 ml-4 flex w-auto flex-col justify-center">
                <p className="font-dm text-sm font-medium text-gray-600">{title}</p>
                <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                    {subtitle === undefined ? "--" : subtitle}
                </h4>
                {/*<div className={`flex items-center text-[14px] text-gray-400 font-semibold `}>
                    <p>
                        {percentage.includes("-")  ? <MdArrowDropDown className="font-bold text-[20px] text-red-500"/> :  <MdArrowDropUp className="font-bold text-[20px] text-green-500"/>}
                    </p>
                    <p className= {percentage.includes("-") ? "text-red-500 font-bold" : "text-green-500 font-bold"}>{percentage.replace("-", "")}{" "}</p>
                    <p className = "text-xs" >&nbsp; Since last month</p>
                </div>*/}
            </div>
        </Card>
    );
};

export default Widget2;
